import { useContext, useEffect } from 'react'

import { getOrderTrackingShippingLabels, useFetch } from '@reveni-io/reveni-ui'

import AppContext from '@/context/AppContext'
import services from '@/services/services'

const useOrderTrackingInfo = ({ orderId }) => {
  const { setContext } = useContext(AppContext)
  const { data, loading } = useFetch(() => services.getOrderTrackingInfo({ orderId }), {
    doInitialRequest: true,
  })

  useEffect(() => {
    if (data) {
      setContext(context => ({
        ...context,
        merchantInfo: {
          ...context.merchantInfo,
          theme: data.portal?.theme,
        },
        orderInfo: { ...data },
      }))
    }
  }, [data, setContext])

  const orderTrackingInfo = data && { ...data, shipping_labels: getOrderTrackingShippingLabels(data) }

  return {
    orderTrackingInfo,
    fetchingOrderTrackingInfo: loading,
  }
}

export default useOrderTrackingInfo
